import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import { getCustomer } from "@/utils/getCustomer";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
export default {
    components: { menberMenu },
    data() {
      return {
        userType:0,
        api: {
          url: "",
          param: "",
          data: "",
          response: {},
          message: ""
        },
      titNames: "Account balance,Recharge",
      titUrls: "/payment/myAccount,",

      OrderStartTime:'',
      OrderEndTime:'',
      IsState:1,
      showModal:false,
      Edlit:false,
      Contraband:true,
      FirstName:'',
      LastName:'',
      CVc:'',
      ExpirationDate:'',
      datelist:false,
      USAmount:'',
      Credit:'',
      //分页
      currentPage: 1,//当前页数
      pageSize:20, //，每页显示的条数
      total:0, //查询结果条数
      datalist:[],
      ordList:[],
      ordListTotal:0,

      carInfo:{},//信用卡信息
      caitotal:0,
      AcunootMsg:'',
      IsAcunootMsg:false,

      clkpa:false,

      IscheckCredit:'',
      IsCredit:false,
      //充值金额
      CarAcunoot:'',
      CheckedAcunoot:false,

      UnPayInfos:{
        UnPayAmountUSD:0,
        UnPayAmountHKD:0,
        UnPayAmountEUR:0, //EUR
        UnPayAmount:0, //CNY
      },
     


      ShowAmount:0,
      USAmount:0,


     //日期输入处理,结束日期不能大于开始日期
     pickerBeginDateBefore: {
      disabledDate: time => {
        let beginDateVal = this.OrderEndTime;
        if (beginDateVal) {
          return time.getTime() > beginDateVal;
        }
      }
    },
    //日期输入处理，结束日期不能大于开始日期
    pickerBeginDateAfter: {
      disabledDate: time => {
        let beginDateVal = this.OrderStartTime;
        if (beginDateVal) {
          return time.getTime() > beginDateVal;
        }
      }
    },

    isChangeCard:false,//是否显示change Carid


    }   
    

},

created() {
  this.GetAmount();
  this.GetCreditCard();
  this.userType = JSON.parse(sessionStorage.getItem("customerInfos")).CustomerOwnerType;
  if(this.$route.query.ordCost){
    this.CarAcunoot=this.$route.query.ordCost
  }
},
mounted(){
  //点击其他区域关闭自定义div
  document.addEventListener('click',(e) => {
      if(this.isChangeCard==true){
        var sp = document.getElementById("changeCardId");
        if(sp && !sp.contains(e.target)) {
          this.isChangeCard=false
        }
      }
  })
},
watch: {

},
computed: {//计算属性周期函数
  ShAmount(){
    let SumAmount = 0 ;
    if(Number(this.USAmount) > Number(this.UnPayInfos.UnPayAmountUSD)){
      this.ShowAmount=SumAmount
     return SumAmount.toFixed(2);
    }else{
      SumAmount =Number(this.UnPayInfos.UnPayAmountUSD)-Number(this.USAmount);
      this.ShowAmount=SumAmount
     return  SumAmount.toFixed(2);
    }
  }
  

},
methods: {


  //点击 Change Card
    clkChangeCard(){
      this.isChangeCard = !this.isChangeCard
    },
    Setmor(code) {
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/CreditCard/SetDefault';
      this.api.param = {
        "ID": code
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {

          this.GetCreditCard();
        }
      })

    },
    // 通知线下支付
    clkNotePay() {
      this.api.url = this.$api03 + '/api/TradeCustomer/Email/RechargeToEmail';
      this.api.param = {
      }
      post(this.api.url, this.api.param).then((res) => {
        if(res.IsOK) {
          this.$alert( 'successfully','',  {
           customClass:'custom-message-box', //自定义添加Class
           confirmButtonText: 'Confirm',
           cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
           closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
           showClose:true,//去掉右上角的取消（X）
           center: true
         }).then(() => {
         }).catch(() => {
         });
        } else {
          this.$alert( 'fail','',  {
           customClass:'custom-message-box', //自定义添加Class
           confirmButtonText: 'Confirm',
           cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
           closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
           showClose:true,//去掉右上角的取消（X）
           center: true
         }).then(() => {
         }).catch(() => {
         });
        }
      })

    },
    checkCai(item){
      let obj={
        Id:item.Id,
        CardNumber:item.CardNumber,
        CardType:item.CardType
      }
      this.carInfo=obj
      this.isChangeCard=false
    },
      //查询信用卡
      GetCreditCard(){
        let that= this;
        this.api.url=this.$api02+'/api/EbayCustomer/CreditCard/Query';
        this.api.param={
          "CardNumber":"" ,
          "CustomerID": 0
        }
        post(this.api.url,this.api.param).then((res)=>{
          if(res.ErrorCode=='C0001'){
            that.ordList=res.Results;
            that.caitotal=res.Total
            if(that.ordList){
              this.ordList.forEach(item => {
                if(item.IsDefault==true){
                  let obj={
                    Id:item.Id,
                    CardNumber:item.CardNumber,
                    CardType:item.CardType
                  }
                  that.carInfo=obj
                }
                
              });

            }
          
          }
        })
      },
      //输入金额不能为字母
      checkNum(ctrValue) {
        if(ctrValue){
          ctrValue = ctrValue.replace(/[^\d\.]/g, '');
          if (ctrValue.indexOf('.') > -1) {
            let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
            if (s.length > 2) {
              ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 3);
            }
          }
               
          return ctrValue;
        }
      },
      //检查金额
      CheckAcunoot(){
        if(this.CarAcunoot=='' || this.CarAcunoot==null){
           this.IsAcunootMsg=true;
           this.AcunootMsg='Plase enter the recharge amount'
           return false
        }else if(this.CarAcunoot==0){
          this.IsAcunootMsg=true;
          this.AcunootMsg='The recharge amount must be greater than 0'
          return false
        }else if(this.CarAcunoot > 99999999.99){
          this.IsAcunootMsg=true;
          this.AcunootMsg='Maximum is 99999999.99'
          return false
        }else {
          this.IsAcunootMsg=false;
          this.AcunootMsg=''
          return true
        }
      },
      GetCheckedAcunoot(){
        if(this.CheckedAcunoot){
          this.CarAcunoot=this.ShowAmount.toFixed(2)
         
        }else{
          this.CarAcunoot='';
        }
      },
      BankCard(code){
        if(code){
        var data=code;
        code= data.replace(/\s/g,'').replace(/(\d{4})\d+(\d{4})$/, "**** **** **** $2")
       return code
      }
      },
      //查询交易记录
      GetAmountSash(){
        let that= this;
        this.api.url=this.$api02+'/api/EbayCustomer/AccountCashUseLog/GetAccountCashUseLog';
        this.api.param={
          "TradeTimeStart": that.OrderStartTime,
          "TradeTimeEnd": that.OrderEndTime,
          "TradeModeValue": 0,
          "TradeType": 0,
          "createtime": "orderbydesc",
            "Skip": that.currentPage,
            "Take": that.pageSize
        }
        post(this.api.url,this.api.param).then((res)=>{
          if(res.ErrorCode=='C0001'){
            that.datalist=res.Results;
          }
        })
      },
      datetime() {
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        let endTime = `${year}-${month}-${day}`;
        let nowTime = endTime; // 当前的时间点
        let befDate = new Date(nowDate.getTime() - 30 * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        let bday = befDate.getDate();
        let startTime = `${byear}-${bmonth}-${bday}`;
        let weekBeforeTime = startTime; // 向前推迟一月的时间点
  
        this.OrderStartTime = weekBeforeTime;
       // console.log(this.OrderStartTime)
        this.OrderEndTime = nowTime;
       // console.log(''+this.OrderEndTime)
      },
    //关闭弹窗
    GetClose(){
        this.showModal=false;
        this.Edlit=false;
        this.datelist=false;


        this.FirstName='';
        this.LastName='';
        this.CVc='';
        this.ExpirationDate='';
        this.Credit='';
        this.IsCredit=false;
     },
      //查询待支付的金额
      GetAmount(){
        let that= this;
        this.api.url=this.$api02+'/api/EbayCustomer/MyBill/GetCusAmount';
        this.api.param={
          "QueryType": 0
        }
        post(this.api.url,this.api.param).then((res)=>{
          if(res.ErrorCode=='C0001'){
            that.UnPayInfos.UnPayAmountUSD=res.Results.UnPayAmountUSD ;
            this.GetUSAmount();
           
          }
        })
      },
       //查询美元金额
    GetUSAmount() {
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/CustomerInfo/GetAccountCurrencyCash';
      this.api.param = {
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001' && res.Results.length>0) {
          res.Results.forEach(e =>{
            if(e.Currency==2){
              that.USAmount = e.UsableCash;
            }
          })
           
        }
      })
    },

    // //查询美元金额
    // GetUSAmount(){
    //   let that= this;
    //   this.api.url=this.$api02+'/api/EbayCustomer/CustomerInfo/GetAccountCurrencyCash';
    //   this.api.param={
    //   }
    //   post(this.api.url,this.api.param).then((res)=>{
    //     if(res.ErrorCode=='C0001'){
    //       that.USAmount=res.Results.UsableCash;
    //     }
    //   })
    // },
     //打开添加信用卡
     credit(){
        this.showModal=true;
        this.datelist=true;
        this.GetCreditCard();
     },
     Addcredit(){
        this.showModal=true;
        this.datelist=false;
        this.Edlit=true;
     },
  
     luhnCheck(){
      var cardNumber= this.Credit;
       var oddSum = 0;
       var evenSum = 0; 
       var i = 0;
       cardNumber=cardNumber.split("").reverse().join("");
       for(i=0;i<cardNumber.length;i++){
         if(i % 2 == 0){
           oddSum += parseInt(cardNumber[i]);
         }
         else{
           var num = parseInt(cardNumber[i])*2;
           num = num > 9 ? parseInt(num.toString()[0]) + parseInt(num.toString()[1]):num;
           evenSum+=num;
         }
       }
       return (oddSum + evenSum) % 10 == 0;
     },
     
      //验证信用卡
      checkCredit(){
        var bankno=this.Credit;
        var lastNum=bankno.substr(bankno.length-1,1);//取出最后一位（与luhn进行比较）
             var first15Num=bankno.substr(0,bankno.length-1);//前15或18位
              var newArr=new Array();
              for(var i=first15Num.length-1;i>-1;i--){    //前15或18位倒序存进数组
                 newArr.push(first15Num.substr(i,1));
              }
              var arrJiShu=new Array();  //奇数位*2的积 <9
             var arrJiShu2=new Array(); //奇数位*2的积 >9
              
              var arrOuShu=new Array();  //偶数位数组
              for(var j=0;j<newArr.length;j++){
                  if((j+1)%2==1){//奇数位
                     if(parseInt(newArr[j])*2<9)
                     arrJiShu.push(parseInt(newArr[j])*2);
                     else
                      arrJiShu2.push(parseInt(newArr[j])*2);
                  }
                 else //偶数位
                 arrOuShu.push(newArr[j]);
              }
              
             var jishu_child1=new Array();//奇数位*2 >9 的分割之后的数组个位数
              var jishu_child2=new Array();//奇数位*2 >9 的分割之后的数组十位数
              for(var h=0;h<arrJiShu2.length;h++){
                 jishu_child1.push(parseInt(arrJiShu2[h])%10);
                  jishu_child2.push(parseInt(arrJiShu2[h])/10);
             }        
             
             var sumJiShu=0; //奇数位*2 < 9 的数组之和
              var sumOuShu=0; //偶数位数组之和
              var sumJiShuChild1=0; //奇数位*2 >9 的分割之后的数组个位数之和
              var sumJiShuChild2=0; //奇数位*2 >9 的分割之后的数组十位数之和
              var sumTotal=0;
              for(var m=0;m<arrJiShu.length;m++){
                  sumJiShu=sumJiShu+parseInt(arrJiShu[m]);
             }
              
              for(var n=0;n<arrOuShu.length;n++){
                  sumOuShu=sumOuShu+parseInt(arrOuShu[n]);
              }
              
              for(var p=0;p<jishu_child1.length;p++){
                  sumJiShuChild1=sumJiShuChild1+parseInt(jishu_child1[p]);
                  sumJiShuChild2=sumJiShuChild2+parseInt(jishu_child2[p]);
              }      
              //计算总和
              sumTotal=parseInt(sumJiShu)+parseInt(sumOuShu)+parseInt(sumJiShuChild1)+parseInt(sumJiShuChild2);
              
              //计算luhn值
              var k= parseInt(sumTotal)%10==0?10:parseInt(sumTotal)%10;        
              var luhn= 10-k;
              
              if(lastNum==luhn){
                this.IscheckCredit=false;
                
              }else{
                this.IscheckCredit=true;
              } 
              if(this.Credit.length<16){
                this.IscheckCredit=true;
              }else{
                this.IscheckCredit=false;
              }
      },
      //验证cvc
      Cvccheck(){
        var reg=/^\d{3,4}$/;
        if(!reg.test(this.CVc)){ //只能输入邮箱格式
          this.IsCredit=true;
        }else{
           this.IsCredit=false;
        }
      },
      //保存信用卡 
      SaveCard(){
        let that = this;
        if(!that.luhnCheck||!that.FirstName||!that.LastName||!that.CVc||!that.ExpirationDate){
          that.IsCredit=true;
          return false;
        }
        if(!(that.Credit.length<= 16)){
          that.IsCredit=true;
          return false;
        }
        let Isdefa=false;
        if(this.Contraband){
          Isdefa=true;
        }
        this.api.url=this.$api02+'/api/EbayCustomer/CreditCard/AddCreditCard';
        this.api.param={
        "FirstName": that.FirstName,
         "LastName": that.LastName,
         "CardNumber": that.Credit,
         "IsDefault":Isdefa,
         "CVC":  that.CVc,
         "ExpirationDate": that.ExpirationDate,
        }
        post(this.api.url,this.api.param).then((res)=>{
          if(res.ErrorCode=='C0001'){
            that.GetClose();
            that.GetCreditCard();
          }else{
            that.IsCredit=true;
          }
        })
      },
      //点击充值
      clkpayValue(){
        if( !this.CheckAcunoot()){
           return false
        }
        let that = this;
        that.clkpa=true;
       this.api.url=this.$api03+'/api/TradeCustomer/CreditCardRecharge/RechargeByIPayLinks';
         this.api.param={
         "Amount": that.CarAcunoot,
         "CreditCardID": that.carInfo.Id
    }
    post(this.api.url,this.api.param).then((res)=>{

      that.recharge(that.CarAcunoot,'Online recharge','iPaylinks',res.IsOK)

      that.clkpa=false;      
      if(res.ErrorCode=='C0001'){        
        this.$confirm( 'Recharge success','Online Recharge',  {
          customClass:'tipsBtn custom-message-box', //自定义添加Class
          confirmButtonText: 'View transaction records',
          cancelButtonText: 'Close',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
           //showCancelButton:false,//去掉取消按钮
          // showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {          
          window.location.href ="/payment/myAccount"
        }).catch(() => {         
          that.CarAcunoot='';
        });
        return false
       
      }else if(res.ErrorCode=='C0002'){
        this.$confirm( 'Recharge failure','Online Recharge',  {
          customClass:'tipsBtn custom-message-box', //自定义添加Class
          confirmButtonText: 'View transaction records',
          cancelButtonText: 'Close',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
           //showCancelButton:false,//去掉取消按钮
          // showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {         
          window.location.href ="/payment/myAccount"          
        }).catch(() => {          
          that.CarAcunoot='';
        });
        return false
        
      }else if(res.ErrorCode=='S0003'){
        //Recharge in process...
        this.$confirm( '<strong>Recharge in process...</strong><p>Your recharge is being processed. If you have any questions, please contact customer service.</p>','Online Recharge',  {
          customClass:'tipsBtn custom-message-box', //自定义添加Class
          dangerouslyUseHTMLString: true , //使用html
          confirmButtonText: 'View transaction records',
          cancelButtonText: 'Close',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
           //showCancelButton:false,//去掉取消按钮
          // showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          window.location.href ="/payment/myAccount"          
        }).catch(() => {
          that.CarAcunoot='';
        });
        return false
        
      }else if(res.ErrorCode=='S0004'){
        // this.$confirm( 'Recharge to be confirmed','Online Recharge',  {
        //   customClass:'custom-message-box', //自定义添加Class
        //   //dangerouslyUseHTMLString: true , //使用html
        //   confirmButtonText: 'View transaction records',
        //   cancelButtonText: 'Close',
        //   cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        //   closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
        //    //showCancelButton:false,//去掉取消按钮
        //   // showClose:false,//去掉右上角的取消（X）
        //   // type: 'warning',
        //   center: true
        // }).then(() => {
        //   window.location.href ="/payment/myAccount"
          
        // }).catch(() => {
        //   that.CarAcunoot='';
        // });
        // return false

        this.$confirm( '<strong>Recharge to be confirmed</strong><p>In order to ensure the transaction security, we will confirm your international credit card payment within 24 hours, and you can check the payment result in the recharge record.</p>','Online Recharge',  {
          customClass:'tipsBtn custom-message-box', //自定义添加Class
          dangerouslyUseHTMLString: true , //使用html
          confirmButtonText: 'View transaction records',
          cancelButtonText: 'Close',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
           //showCancelButton:false,//去掉取消按钮
          // showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          window.location.href ="/payment/myAccount"          
        }).catch(() => {
          that.CarAcunoot='';
        });
        return false
      }else if(res.ErrorCode== 'S0002') {
        this.Addcredit()
        //当返回为未增添加信用卡,就弹出新增信用卡
      }

    })
  }    

}

};


// WEBPACK FOOTER //
// ./src/assets/js/userCenter/payment/myPayment.js